import { getActiveVoiceProvider } from "./providers";
import type { AudioChunk, TranscribeRequest, SynthesizeRequest } from "./types";

/** Thin, store-agnostic pass-through — mirrors `chatService.ts`'s role for
 * the AI layer. There's no orchestration to do yet since there's only one
 * (stub) provider, but this is the seam `useVoice` calls through so a real
 * engine change never touches the hook. */
export function transcribe(request: TranscribeRequest): Promise<string> {
  return getActiveVoiceProvider().transcribe(request);
}

export function synthesize(request: SynthesizeRequest): AsyncGenerator<AudioChunk> {
  return getActiveVoiceProvider().synthesize(request);
}
